import { StatelessComponent } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/external/ExternalHeader/ExternalHeader.styl'
import LogoContainer from 'components/features/pfm/Logo/LogoContainer'
import ExternalHeaderButtons from 'components/features/external/ExternalHeaderButtons/ExternalHeaderButtons'
import { HeaderTheme } from 'interfaces/component'

type ExternalHeaderProps = {
  theme: HeaderTheme
  hasExternalNavigation?: boolean
  hasLoginButton?: boolean
  hasJoinButton?: boolean
  isSticky: boolean
}

const ExternalHeader: StatelessComponent<ExternalHeaderProps> = (props) => {
  const className = cn(styles.header, {
    [styles.withoutExternalNavigation]: !props.hasExternalNavigation,
  })

  return (
    <header className={ className } >
      <div className={ styles.logoWrapper }>
        <LogoContainer
          size='responsive'
          theme={ props.theme === 'light' ? 'dark' : 'light' }
        />
      </div>
      <ExternalHeaderButtons { ...props } />
    </header>
  )
}

ExternalHeader.defaultProps = {
  hasExternalNavigation: false,
  hasLoginButton: false,
  hasJoinButton: false,
  isSticky: false,
}

export default ExternalHeader
